/*
 * Module for the Index/_Withholdings view
*/

rs.module("ui/content/benefits/withholdings/withholdings",

    [],

    function () {

        // Initialize the module
        function initialize(listApi, backendUrls) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                listApi.detail.updateTitle(context.WithholdingType + " Withholding");

                $.get(
                    backendUrls.getDetail,
                    {
                        withholdingKey: context.WithholdingKey,
                        changeFlag: context.ChangeFlag,
                        calculatedAmount: context.CalculatedWithholdingAmount
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail, clear title
                        listApi.detail.clearDetail();
                        listApi.detail.updateTitle("");
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);